/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

import {
  StyledTopicsHeader,
  StyledTopicSideBarInfoBox,
  StyledSidebarTopicButton,
} from "../../../common/StyledComponents/SideBarComponents";
import {
  CustomInput,
  SearchBox,
  ChatSearchButton,
  SmallIcon,
} from "../../../common/chatComponents/ScreenSearchSection";
import dragIcon from "../../../assets/images/task/dragicon.svg";
import addBlackIcom from "../../../assets/images/chats/AddBlack.svg";
import searchIcon from "../../../assets/images/chats/gallery_active.svg";
import InputDialogComponent from "../../../components/InputDialog";
import SelectCheckBox from "../../../assets/images/chats/selectcheckbox.svg";
import UnSelectCheckBox from "../../../assets/images/chats/blankcheckbox.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  createTopic,
  updateTopic,
} from "../../../appStore/actions/topics/action";
import {
  createSubtopic,
  updateSubtopic,
  deleteSubtopic,
  reorderSubtopics,
} from "../../../appStore/actions/subtopics/action";
import {
  handleDeleteGroupTopic,
  handleFetchMessages,
  handleMoveChatToAnotherTopic,
  handleMoveChatToSubtopic,
  handleReOrderToipc,
} from "../../../appStore/actions/ArkchatGroup/action";
import {
  handleAppSelectedTopic,
  handleAppSelectedTopicToSaveMsg,
  handleChangeTopicOpen,
  handleAppSelectedSubtopic,
  handleAppSelectedSubtopicToSaveMsg,
  handleChangeSubtopicOpen,
} from "../../../appStore/actions/AppState/action";
import { showToastMsg } from "../../../appStore/actions/global/action";

import {
  colorSchemes,
  crossIcon,
  crossIconDiv,
  fontSizeSchemes,
} from "../../../assets/commonFunction";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import EditPencil from "../../../common/SvgImageView/EditPencil";
import { deleteTopicData } from "../../../config/db";
import { GET_TOPIC_DONE } from "../../../appStore/actions/topics";
import { GET_SUBTOPIC_DONE } from "../../../appStore/actions/subtopics";
import useAppSelectors from "../../../customHooks/useAppSelectors";
import fileIcon from "../../../assets/images/chats/fileIcon.svg";


const classes = {
  checkBoxStyle: {
    width: 25,
    height: 25,
    cursor: "pointer",
  },
  headingText: {
    color: "black",
    fontSize: "14px",
    fontWeight: "400",
    "@media (max-width: 63em)": {
      fontSize: "0.8rem",
    },
  },
  drawerBody: {
    minWidth: "393px",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    backgroundColor: "#183243",
    color: "#fff",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconDivRed: {
    backgroundColor: "#DB0011",
    position: "relative",
    height: "30px",
    width: "30px",
    padding: "4px",
    borderRadius: "2px",
    cursor: "pointer",
  },
  iconn: crossIcon,
  iconnWhite: {
    color: "white",
    height: "100%",
    width: "100%",
  },
  selectedItem: {
    backgroundColor: "#E1E1E1",
    color: "#000",
    cursor: "pointer",
  },
  nonselectedItem: {
    color: "#000",
    cursor: "pointer",
  },
};

// --- Sortable subtopic row ---
const SortableSubtopicItem = ({
  ele,
  selectedTopic,
  selectedSubtopic,
  isMoveTopicTriggered,
  isChangeTopicOpen,
  isTopicEditActive,
  selectedChangeSubtopic,
  selectedSubtopicToSaveMsg,
  handleChangeMoveTopic,
  handleSaveSubtopic,
  handleSelectedSubtopic,
  handleEditSubtopicOpen,
  parentTopicId,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: ele?.id });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.5 : 1, width: "100%" };

  return (
    <Box ref={setNodeRef} style={style} display="flex" alignItems="center" width={"90%"} mt={"0.4rem"} ml={"auto"} pl={"1rem"}>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        marginRight={"0.3rem"}
        sx={{ cursor: "grab", borderRadius: "0.1rem", userSelect: "none", touchAction: "none", "&:hover": { backgroundColor: "#f0f0f0" }, "&:active": { cursor: "grabbing" } }}
        {...attributes}
        {...listeners}
      >
        <img src={dragIcon} alt="dragIcon" style={{ width: "12px", height: "12px", opacity: 0.5 }} />
      </Box>


      <Box
        display={"flex"}
        alignItems={"center"}
        width={"100%"}
        padding={"0.15rem 0.5rem"}
        backgroundColor={colorSchemes.transparent}
        borderRadius="0.1rem"
        onClick={() => !isMoveTopicTriggered && handleSelectedSubtopic(ele, parentTopicId)}
        sx={
          selectedSubtopic?.id === ele?.id && !isMoveTopicTriggered && !isChangeTopicOpen
            ? classes.selectedItem
            : classes.nonselectedItem
        }
      >
        <Typography flex={1} fontSize="0.78rem" fontWeight="400" color="#444" variant="h6" title={ele?.name}>
          {ele?.name?.length > 22 ? `${ele?.name.slice(0, 22)}...` : ele?.name}
        </Typography>

        {isTopicEditActive && !isMoveTopicTriggered && !isChangeTopicOpen && (
          <Button
            onClick={(e) => { e.stopPropagation(); handleEditSubtopicOpen(ele); }}
            size="small"
            variant="contained"
            sx={{ padding: "8px", border: `0.5px solid ${colorSchemes.black}`, backgroundColor: colorSchemes.white, width: "1.7rem", height: "1.7rem", minWidth: "unset", minHeight: "unset", borderRadius: "0.15rem", boxShadow: "none", flexShrink: 0, "&:hover": { backgroundColor: colorSchemes.white, boxShadow: "none" } }}
          >
            <EditPencil color={"#000000"} />
          </Button>
        )}

        {isMoveTopicTriggered && selectedChangeSubtopic?.id === ele?.id && (
          <Button
            onClick={handleSaveSubtopic}
            size="small"
            variant="outlined"
            sx={{ padding: "2.3px", zIndex: 11, mr: "4px", minWidth: "2.8rem", minHeight: "unset", height: "25px", fontSize: "0.7rem", textTransform: "none", borderRadius: "0.15rem", flexShrink: 0, color: colorSchemes.black, borderColor: colorSchemes.black, backgroundColor: colorSchemes.white, "&:hover": { borderColor: colorSchemes.black, backgroundColor: colorSchemes.white } }}
          >
            Save
          </Button>
        )}

        {(isMoveTopicTriggered || isChangeTopicOpen) && (
          <Box onClick={() => handleChangeMoveTopic(ele, true)} sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
            <img
              style={classes.checkBoxStyle}
              src={selectedChangeSubtopic?.id === ele?.id ? SelectCheckBox : UnSelectCheckBox}
              alt="select"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

// --- Sortable topic row (with subtopics below) ---
const SortableItem = ({
  ele,
  i,
  isMoveTopicTriggered,
  selectedTopic,
  selectedSubtopic,
  isChangeTopicOpen,
  isTopicEditActive,
  selectedChangeTopic,
  selectedChangeSubtopic,
  selectedTopicToSaveMsg,
  selectedSubtopicToSaveMsg,
  subtopicsForTopic,
  handleChangeMoveTopic,
  handleSave,
  handleSaveSubtopic,
  handleSelectedTopic,
  handleSelectedSubtopic,
  handleEditTopicOpen,
  handleEditSubtopicOpen,
  handleAddSubtopicOpen,
  handleSubtopicDragEnd,
  userData,
  selectedGroup,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: ele?.id });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.5 : 1, width: "100%" };

  const subtopicSensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 0 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  return (
    <Box {...(i !== 0 ? { ref: setNodeRef, style } : {})} display="flex" flexDirection="column" width={"95%"} mt={"0.5rem"} marginLeft="auto">
      {/* Topic row */}
      <Box display="flex" alignItems="center" width={"100%"}>
        {i !== 0 && (
          <Box
            display={"flex"} alignItems={"center"} justifyContent={"center"} marginRight={"0.3rem"}
            sx={{ cursor: "grab", borderRadius: "0.1rem", userSelect: "none", touchAction: "none", "&:hover": { backgroundColor: "#f0f0f0" }, "&:active": { cursor: "grabbing" } }}
            {...attributes} {...listeners}
          >
            <img src={dragIcon} alt="dragIcon" style={{ width: "14px", height: "14px", opacity: 0.6 }} />
          </Box>
        )}

        <Box
          display="flex"
          alignItems="center"
          flex={1}
          borderRadius="0.1rem"
          onClick={() => !isMoveTopicTriggered && handleSelectedTopic(ele)}
          sx={selectedTopic?.id === ele?.id && !isMoveTopicTriggered && !isChangeTopicOpen ? classes.selectedItem : classes.nonselectedItem}
        >
          <Box
            display={"flex"} alignItems={"center"} flex={1} padding={"0.2rem 0.5rem"} backgroundColor={colorSchemes.transparent} borderRadius="0.1rem"
          >
            <Typography flex={1} fontSize="0.82rem" fontWeight="400" color="Black" variant="h6" title={ele?.name}>
              {ele?.name?.length > 24 ? `${ele?.name.slice(0, 24)}...` : ele?.name}
            </Typography>

            {i !== 0 && isTopicEditActive && !isMoveTopicTriggered && !isChangeTopicOpen && (
              <Button
                onClick={(e) => { e.stopPropagation(); handleEditTopicOpen(ele); }}
                size="small" variant="contained"
                sx={{ padding: "8px", border: `0.5px solid ${colorSchemes.black}`, backgroundColor: colorSchemes.white, width: "1.87rem", height: "1.87rem", minWidth: "unset", minHeight: "unset", borderRadius: "0.15rem", boxShadow: "none", flexShrink: 0, "&:hover": { backgroundColor: colorSchemes.white, boxShadow: "none" } }}
              >
                <EditPencil color={"#000000"} />
              </Button>
            )}

            {isMoveTopicTriggered && selectedChangeTopic?.id === ele?.id && (
              <Button
                onClick={handleSave}
                size="small"
                variant="outlined"
                sx={{ padding: "2.3px", zIndex: 11, mr: "4px", minWidth: "2.8rem", minHeight: "unset", height: "25px", fontSize: "0.7rem", textTransform: "none", borderRadius: "0.15rem", flexShrink: 0, color: colorSchemes.black, borderColor: colorSchemes.black, backgroundColor: colorSchemes.white, "&:hover": { borderColor: colorSchemes.black, backgroundColor: colorSchemes.white } }}
              >
                Save
              </Button>
            )}

            {(isMoveTopicTriggered || isChangeTopicOpen) && (
              <Box onClick={() => handleChangeMoveTopic(ele, false)} sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                <img
                  style={classes.checkBoxStyle}
                  src={selectedChangeTopic?.id === ele?.id ? SelectCheckBox : UnSelectCheckBox}
                  alt="select"
                />
              </Box>
            )}
          </Box>

          {/* + Subtopic inline button — only visible when this topic is selected */}
          {i !== 0 && !isMoveTopicTriggered && !isChangeTopicOpen && selectedTopic?.id === ele?.id && (
            <Button
              onClick={(e) => { e.stopPropagation(); handleAddSubtopicOpen(ele); }}
              sx={{
                mr: "0.2rem",
                padding: "0 6px",
                fontSize: "0.7rem",
                fontWeight: 500,
                minWidth: "unset",
                minHeight: "unset",
                height: "22px",
                border: "1px solid grey",
                color: "black",
                textTransform: "none",
                bgcolor: colorSchemes.white,
                borderRadius: "3px",
                lineHeight: 1,
                "&:hover": { border: "1px solid grey", bgcolor: colorSchemes.white },
              }}
              variant="outlined"
            >
              + Subtopic
            </Button>
          )}
        </Box>
      </Box>

      {/* Subtopics list — visible when this topic is selected, or in move/change mode */}
      {subtopicsForTopic?.length > 0 && (selectedTopic?.id === ele?.id || isMoveTopicTriggered || isChangeTopicOpen) && (
        <Box ml={"0.4rem"} mt={"0.2rem"}>
          <DndContext
            sensors={subtopicSensors}
            collisionDetection={closestCenter}
            onDragEnd={({ active, over }) => handleSubtopicDragEnd(ele.id, subtopicsForTopic, active, over)}
          >
            <SortableContext items={subtopicsForTopic.map(s => s.id)} strategy={verticalListSortingStrategy}>
              {subtopicsForTopic.map((sub) => (
                <SortableSubtopicItem
                  key={sub.id}
                  ele={sub}
                  selectedTopic={selectedTopic}
                  selectedSubtopic={selectedSubtopic}
                  isMoveTopicTriggered={isMoveTopicTriggered}
                  isChangeTopicOpen={isChangeTopicOpen}
                  isTopicEditActive={isTopicEditActive}
                  selectedChangeSubtopic={selectedChangeSubtopic}
                  selectedSubtopicToSaveMsg={selectedSubtopicToSaveMsg}
                  handleChangeMoveTopic={handleChangeMoveTopic}
                  handleSaveSubtopic={handleSaveSubtopic}
                  handleSelectedSubtopic={handleSelectedSubtopic}
                  handleEditSubtopicOpen={handleEditSubtopicOpen}
                  parentTopicId={ele.id}
                />
              ))}
            </SortableContext>
          </DndContext>
        </Box>
      )}

    </Box>
  );
};

// --- Main Topics Component ---
const Topics = ({
  setisTopicOpen,
  handleSelectedTopic,
  isMoveTopicTriggered,
  setMoveTopicTriggered,
  moveTopicMsgId,
  setMoveTopicMsgId,
  isCollapsed,
  setCollapsed,
}) => {
  const [isAddTopicOpen, setIsAddTopicOpen] = useState(false);
  const [isEditTopicOpen, setIsEditTopicOpen] = useState(false);
  const [isAddSubtopicOpen, setIsAddSubtopicOpen] = useState(false);
  const [isEditSubtopicOpen, setIsEditSubtopicOpen] = useState(false);
  const [topicName, setTopicName] = useState("");
  const [subtopicName, setSubtopicName] = useState("");
  const [searchToipcQuery, setSearchToipcQuery] = useState("");
  const [topicDetail, setTopicDetail] = useState({});
  const [subtopicDetail, setSubtopicDetail] = useState({});
  const [addSubtopicParent, setAddSubtopicParent] = useState(null);
  const [selectedChangeTopic, setSelectedChangeTopic] = useState(null);
  const [selectedChangeSubtopic, setSelectedChangeSubtopic] = useState(null);
  const [isDeleteLoading, setDeleteLoading] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [isTopicEditActive, setIsTopicEditActive] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.profile?.profileData);
  const selectedGroup = useSelector((state) => state?.appStateData?.selectedGroupData);
  const selectedTopic = useSelector((state) => state?.appStateData?.selectedTopicData);
  const selectedSubtopic = useSelector((state) => state?.appStateData?.selectedSubtopicData);
  const selectedTopicToSaveMsg = useSelector((state) => state?.appStateData?.selectedTopicToSaveMsg);
  const selectedSubtopicToSaveMsg = useSelector((state) => state?.appStateData?.selectedSubtopicToSaveMsg);
  const groupTopicData = useSelector((state) => state?.topic?.groupTopicData);
  const groupSubtopicData = useSelector((state) => state?.subtopic?.groupSubtopicData);
  const isChangeTopicOpen = useSelector((state) => state?.appStateData?.isChangeTopicOpen);

  const filteredTopicData = groupTopicData?.data?.length
    ? groupTopicData.data
      .filter((item) => item?.name?.toLowerCase().includes(searchToipcQuery.toLowerCase()))
      .sort((a, b) => {
        if (a?.name?.toLowerCase() === "general") return -1;
        if (b?.name?.toLowerCase() === "general") return 1;
        return a.order - b.order;
      })
    : [];

  const getSubtopicsForTopic = (topicId) =>
    (groupSubtopicData || []).filter((s) => (s.topicId || s.topic_id) === topicId).sort((a, b) => a.order - b.order);

  // ----- Topic handlers -----
  const handleInputChange = (e) => setTopicName(e.target.value);

  const handleAddTopic = () => {
    const formData = { group_id: selectedGroup?.id, name: topicName, description: "", subscriber_id: userData?.data?.activeSubscriber?.id };
    if (topicName) {
      setLoading(true);
      dispatch(createTopic(formData)).then(() => { setLoading(false); setIsAddTopicOpen(false); setTopicName(""); });
    }
  };

  const handleEditTopicOpen = (data) => { setTopicDetail(data); setIsEditTopicOpen(true); };
  const handleEditTopicInputChange = (e) => setTopicDetail({ ...topicDetail, name: e.target.value });

  const handleEditTopic = () => {
    if (topicDetail) {
      setLoading(true);
      // The topic-updated signal reloads the list (as for a new topic).
      dispatch(updateTopic({ name: topicDetail?.name }, topicDetail?.id)).then(() => {
        setLoading(false); setIsEditTopicOpen(false);
      });
    }
  };

  const handleAlternateBtnClick = async () => {
    setDeleteLoading(true);
    await dispatch(handleDeleteGroupTopic(topicDetail?.id)).then((res) => {
      setDeleteLoading(false);
      if (res?.data?.status) {
        deleteTopicData(topicDetail?.id);
        setIsEditTopicOpen(false);
        dispatch(showToastMsg(res?.data?.message));
      } else {
        dispatch(showToastMsg(res?.data?.message || "Something went wrong !"));
      }
    });
    // The topic-deleted signal reloads the list.
  };

  // ----- Subtopic handlers -----
  const handleAddSubtopicOpen = (parentTopic) => { setAddSubtopicParent(parentTopic); setSubtopicName(""); setIsAddSubtopicOpen(true); };

  const handleAddSubtopic = () => {
    if (!subtopicName || !addSubtopicParent) return;
    setLoading(true);
    dispatch(createSubtopic({
      topic_id: addSubtopicParent.id,
      group_id: selectedGroup?.id,
      name: subtopicName,
      description: "",
      subscriber_id: userData?.data?.activeSubscriber?.id,
    })).then(() => {
      // The subtopic-created signal reloads the list.
      setLoading(false); setIsAddSubtopicOpen(false);
    });
  };

  const handleEditSubtopicOpen = (data) => { setSubtopicDetail(data); setIsEditSubtopicOpen(true); };
  const handleEditSubtopicInputChange = (e) => setSubtopicDetail({ ...subtopicDetail, name: e.target.value });

  const handleEditSubtopic = () => {
    if (subtopicDetail) {
      setLoading(true);
      // The subtopic-updated signal reloads the list.
      dispatch(updateSubtopic({ name: subtopicDetail?.name }, subtopicDetail?.id)).then(() => {
        setLoading(false); setIsEditSubtopicOpen(false);
      });
    }
  };

  const handleDeleteSubtopic = async () => {
    setDeleteLoading(true);
    const res = await dispatch(deleteSubtopic(subtopicDetail?.id));
    setDeleteLoading(false);
    if (res?.status) {
      // The subtopic-deleted signal reloads the list.
      dispatch(showToastMsg(res?.message));
    } else {
      dispatch(showToastMsg(res?.message || "Something went wrong !"));
    }
    setIsEditSubtopicOpen(false);
  };

  const handleSelectedSubtopic = (subtopicData, parentTopicId) => {
    const parentTopic = groupTopicData?.data?.find((t) => t.id === parentTopicId);
    dispatch(handleAppSelectedTopic(parentTopic || null));
    dispatch(handleAppSelectedTopicToSaveMsg(parentTopic || null));
    dispatch(handleAppSelectedSubtopic(subtopicData));
    dispatch(handleAppSelectedSubtopicToSaveMsg(subtopicData));
    dispatch(handleFetchMessages(selectedGroup?.pnId, parentTopicId, { topicId: parentTopicId, subtopicId: subtopicData?.id }));
  };

  // ----- Move to topic/subtopic handlers -----
  const handleChangeMoveTopic = (itemData, isSubtopic) => {
    if (isChangeTopicOpen) {
      if (isSubtopic) {
        dispatch(handleAppSelectedSubtopicToSaveMsg(itemData));
      } else {
        dispatch(handleAppSelectedTopicToSaveMsg(itemData));
        dispatch(handleAppSelectedSubtopicToSaveMsg(null));
      }
      dispatch(handleChangeTopicOpen(false));
    } else {
      if (isSubtopic) {
        setSelectedChangeSubtopic(itemData);
        setSelectedChangeTopic(null);
      } else {
        setSelectedChangeTopic(itemData);
        setSelectedChangeSubtopic(null);
      }
    }
  };

  const handleSave = () => {
    if (selectedChangeTopic) {
      dispatch(handleMoveChatToAnotherTopic(moveTopicMsgId?.pnId, moveTopicMsgId?.timetoken, selectedChangeTopic?.id)).then(() => {
        setMoveTopicMsgId(null); setMoveTopicTriggered(false);
        dispatch(handleAppSelectedSubtopic(null));
        dispatch(handleAppSelectedSubtopicToSaveMsg(null));
        dispatch(handleFetchMessages(selectedGroup?.pnId, selectedTopic?.id, { topicId: selectedTopic?.id, subtopicId: selectedSubtopic?.id || "" }));
      });
    }
  };

  const handleSaveSubtopic = () => {
    if (selectedChangeSubtopic) {
      const parentTopic = groupTopicData?.data?.find((t) => t.id === (selectedChangeSubtopic.topicId || selectedChangeSubtopic.topic_id));
      dispatch(handleMoveChatToSubtopic(moveTopicMsgId?.pnId, moveTopicMsgId?.timetoken, parentTopic?.id || "", selectedChangeSubtopic?.id)).then(() => {
        setMoveTopicMsgId(null); setMoveTopicTriggered(false);
        dispatch(handleFetchMessages(selectedGroup?.pnId, selectedTopic?.id, { topicId: selectedTopic?.id, subtopicId: selectedSubtopic?.id || "" }));
      });
    }
  };

  const handleClickAllMessages = () => {
    dispatch(handleAppSelectedTopic(null));
    dispatch(handleAppSelectedSubtopic(null));
    dispatch(handleFetchMessages(selectedGroup?.pnId, null));
  };

  // Drag and drop
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 0 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  const handleSubtopicDragEnd = (topicId, currentSubtopics, active, over) => {
    if (!over || active.id === over.id) return;
    const oldIdx = currentSubtopics.findIndex((s) => s.id === active.id);
    const newIdx = currentSubtopics.findIndex((s) => s.id === over.id);
    if (oldIdx === -1 || newIdx === -1) return;
    const reordered = arrayMove(currentSubtopics, oldIdx, newIdx).map((s, order) => ({ ...s, order }));
    const previousSubtopics = [...groupSubtopicData];
    const updatedAll = groupSubtopicData.map((s) => reordered.find((r) => r.id === s.id) || s);
    dispatch({ type: GET_SUBTOPIC_DONE, payload: updatedAll });
    const reorderedPayload = reordered.map((s, order) => ({ id: s.id, order }));
    dispatch(reorderSubtopics({ order: reorderedPayload }, topicId)).then((res) => {
      if (!res?.data?.status) {
        dispatch({ type: GET_SUBTOPIC_DONE, payload: previousSubtopics });
        dispatch(showToastMsg(res?.data?.message || "Failed to reorder subtopics"));
      }
    });
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    setActiveId(null);
    document.body.style.overflow = "auto";
    if (!over || active.id === over.id) return;
    const oldIndex = filteredTopicData.findIndex((item) => item.id === active.id);
    const newIndex = filteredTopicData.findIndex((item) => item.id === over.id);
    if (oldIndex === -1 || newIndex === -1) return;
    const reorderedTopicList = arrayMove(filteredTopicData, oldIndex, newIndex).map((item, order) => ({ ...item, order }));
    dispatch({ type: GET_TOPIC_DONE, payload: reorderedTopicList });
    const reorderedPayload = reorderedTopicList.map((item, order) => ({ id: item.id, order }));
    dispatch(handleReOrderToipc({ order: reorderedPayload }, selectedGroup?.id)).then((res) => {
      if (!res?.data?.status) {
        dispatch({ type: GET_TOPIC_DONE, payload: filteredTopicData });
        dispatch(showToastMsg(res?.data?.message || res?.message));
      }
    });
  };

  if (isCollapsed) {
    return (
      <Stack
        bgcolor={"#FDFDFD"}
        height={"100%"}
        alignItems={"center"}
        sx={{ cursor: "pointer", overflow: "hidden" }}
        onClick={() => setCollapsed(false)}
      >
        <Box
          width={"100%"}
          minHeight={"38px"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <KeyboardDoubleArrowRightIcon
            sx={{ fontSize: "1.3rem", color: "#000" }}
          />
        </Box>
        <Typography
          variant="h6"
          sx={{
            ...classes.headingText,
            writingMode: "vertical-rl",
            transform: "rotate(180deg)",
            mt: "0.5rem",
            whiteSpace: "nowrap",
          }}
        >
          Topics
        </Typography>
      </Stack>
    );
  }

  return (
    <React.Fragment>
      <Stack sx={{ paddingLeft: "0", bgcolor: "#FDFDFD", height: "100%", overflow: "hidden" }}>
        <StyledTopicsHeader sx={{ bgcolor: "#FDFDFD" }}>
          <Box display="flex" alignItems="center" gap={"0.5rem"} flex={1} minWidth={0}>
            {/* <Typography sx={classes.iconDiv}>
              <CloseIcon sx={classes.iconn} onClick={() => { setisTopicOpen(false); setMoveTopicMsgId(null); setMoveTopicTriggered(false); dispatch(handleChangeTopicOpen(false)); }} />
            </Typography> */}
            <KeyboardDoubleArrowLeftIcon
              onClick={() => setCollapsed(true)}
              sx={{ fontSize: "1.3rem", color: "#000", cursor: "pointer", flexShrink: 0 }}
            />
            {isSearchOpen ? (
              <SearchBox sx={{ flex: 1, mr: "0.3rem", height: "1.87rem", boxSizing: "border-box" }}>
                <CustomInput
                  autoFocus
                  value={searchToipcQuery}
                  onChange={(e) => setSearchToipcQuery(e.target.value)}
                  placeholder="Search Topics"
                />
                <ChatSearchButton
                  size="small"
                  variant="contained"
                  onClick={() => { setIsSearchOpen(false); setSearchToipcQuery(""); }}
                >
                  <CloseIcon sx={{ fontSize: "1rem", color: "#000" }} />
                </ChatSearchButton>
              </SearchBox>
            ) : (
              <Box>
                <Typography sx={classes.headingText} variant="h6">Topics</Typography>
              </Box>
            )}
          </Box>
          <Box display="flex" alignItems="center" gap={"0.3rem"} flexShrink={0}>
            {!isSearchOpen && (
              <Button
                onClick={() => setIsSearchOpen(true)}
                size="small"
                variant="contained"
                sx={{
                  padding: "8px",
                  border: "none",
                  backgroundColor: "transparent",
                  width: "1.87rem",
                  height: "1.87rem",
                  minWidth: "unset",
                  minHeight: "unset",
                  borderRadius: "0.15rem",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                  },
                }}
              >
                <SmallIcon src={searchIcon} />
              </Button>
            )}
            <Button
              onClick={() => setIsTopicEditActive(!isTopicEditActive)}
              size="small" variant="contained"
              sx={{ display: groupTopicData?.data?.some((item) => item?.name?.toLowerCase() !== "general") ? "inline-flex" : "none", padding: "8px", border: `0.5px solid ${colorSchemes.black}`, backgroundColor: isTopicEditActive ? colorSchemes.chipIconBlueColor : colorSchemes.white, width: "1.87rem", height: "1.87rem", minWidth: "unset", minHeight: "unset", borderRadius: "0.15rem", boxShadow: "none", "&:hover": { backgroundColor: isTopicEditActive ? colorSchemes.chipIconBlueColor : colorSchemes.white, boxShadow: "none" } }}
            >
              <EditPencil color={isTopicEditActive ? "#FFFF" : "#000000"} />
            </Button>
            <Button
              onClick={() => setIsAddTopicOpen(true)}
              size="small"
              variant="contained"
              sx={{
                padding: "8px",
                border: `0.5px solid ${colorSchemes.black}`,
                backgroundColor: colorSchemes.white,
                width: "1.87rem",
                height: "1.87rem",
                minWidth: "unset",
                minHeight: "unset",
                borderRadius: "0.15rem",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: colorSchemes.white,
                  boxShadow: "none",
                },
              }}
            >
              <img src={addBlackIcom} alt="add topic" />
            </Button>
          </Box>
        </StyledTopicsHeader>

        <StyledTopicSideBarInfoBox
          sx={{
            bgcolor: "#FDFDFD",
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            padding: "0.3rem 0.3rem 0",
          }}
        >
          {isAddTopicOpen && (
            <InputDialogComponent title="Add Topic" open={isAddTopicOpen} handleClose={() => setIsAddTopicOpen(false)} onChange={handleInputChange} btnLabel="Save" isType="add" inputLable="Topic Name" onClick={handleAddTopic} isLoading={isLoading} />
          )}

          <Box flex={1} minHeight={0} mt={"0.4rem"} overflow="scroll" sx={{ scrollbarWidth: "none", "&::-webkit-scrollbar": { width: "0px" } }}>

            {isEditTopicOpen && (
              <InputDialogComponent title="Edit/Delete Topic" open={isEditTopicOpen} handleClose={() => setIsEditTopicOpen(false)} onChange={handleEditTopicInputChange} btnLabel="Save" isType="edit" alternateBtnLabel="Delete" value={topicDetail?.name} inputLable="Topic Name" onClick={handleEditTopic} handleAlternateBtnClick={handleAlternateBtnClick} isDeleteLoading={isDeleteLoading} isLoading={isLoading} />
            )}

            {isAddSubtopicOpen && (
              <InputDialogComponent
                title={`Add Subtopic under "${addSubtopicParent?.name}"`}
                open={isAddSubtopicOpen}
                handleClose={() => setIsAddSubtopicOpen(false)}
                onChange={(e) => setSubtopicName(e.target.value)}
                btnLabel="Save"
                isType="add"
                inputLable="Subtopic Name"
                onClick={handleAddSubtopic}
                isLoading={isLoading}
              />
            )}

            {isEditSubtopicOpen && (
              <InputDialogComponent
                title="Edit/Delete Subtopic"
                open={isEditSubtopicOpen}
                handleClose={() => setIsEditSubtopicOpen(false)}
                onChange={handleEditSubtopicInputChange}
                btnLabel="Save"
                isType="edit"
                alternateBtnLabel="Delete"
                value={subtopicDetail?.name}
                inputLable="Subtopic Name"
                onClick={handleEditSubtopic}
                handleAlternateBtnClick={handleDeleteSubtopic}
                isDeleteLoading={isDeleteLoading}
                isLoading={isLoading}
              />
            )}

            {isChangeTopicOpen && (
              <Box display="flex" alignItems="center" gap={"0.6rem"} mt={"0.4rem"} bgcolor={"#183243"}>
                <Typography sx={classes.iconDivRed}>
                  <CloseIcon sx={classes.iconnWhite} onClick={() => dispatch(handleChangeTopicOpen(false))} />
                </Typography>
                <Box>
                  <Typography color={"#fff"} fontSize={"0.84rem"}>Change Topic</Typography>
                </Box>
              </Box>
            )}

            {/* <Box position={"relative"} width={"100%"} padding={"0.2rem 0.5rem"} borderRadius="0.1rem" title={"View Topic wise Chats"}>
              <Typography mt={"0.5rem"} fontSize={"0.84rem"} fontWeight={600}>View Topic wise Chats</Typography>
            </Box> */}

            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
              onDragStart={(event) => { setActiveId(event.active.id); document.body.style.overflow = "hidden"; }}
              onDragCancel={() => { setActiveId(null); document.body.style.overflow = "auto"; }}
            >
              <SortableContext items={filteredTopicData?.map((item) => item?.id)} strategy={verticalListSortingStrategy}>
                {filteredTopicData?.map((ele, i) => (
                  <SortableItem
                    key={ele?.id + "topicdata" + i}
                    ele={ele}
                    i={i}
                    isMoveTopicTriggered={isMoveTopicTriggered}
                    selectedTopic={selectedTopic}
                    selectedSubtopic={selectedSubtopic}
                    isChangeTopicOpen={isChangeTopicOpen}
                    isTopicEditActive={isTopicEditActive}
                    selectedChangeTopic={selectedChangeTopic}
                    selectedChangeSubtopic={selectedChangeSubtopic}
                    selectedTopicToSaveMsg={selectedTopicToSaveMsg}
                    selectedSubtopicToSaveMsg={selectedSubtopicToSaveMsg}
                    subtopicsForTopic={getSubtopicsForTopic(ele.id)}
                    handleChangeMoveTopic={handleChangeMoveTopic}
                    handleSave={handleSave}
                    handleSaveSubtopic={handleSaveSubtopic}
                    handleSelectedTopic={handleSelectedTopic}
                    handleSelectedSubtopic={handleSelectedSubtopic}
                    handleEditTopicOpen={handleEditTopicOpen}
                    handleEditSubtopicOpen={handleEditSubtopicOpen}
                    handleAddSubtopicOpen={handleAddSubtopicOpen}
                    handleSubtopicDragEnd={handleSubtopicDragEnd}
                    userData={userData}
                    selectedGroup={selectedGroup}
                  />
                ))}
              </SortableContext>
              <DragOverlay>
                {activeId ? (
                  <div style={{ background: "white", border: "1px solid #ddd", borderRadius: "4px", padding: "8px 12px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", opacity: 0.9, pointerEvents: "none", userSelect: "none", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: "grab" }}>
                    {filteredTopicData.find((item) => item?.id === activeId)?.name || "Dragging..."}
                  </div>
                ) : null}
              </DragOverlay>
            </DndContext>
          </Box>

          {isMoveTopicTriggered && !isChangeTopicOpen && (
            <Box mt={"3rem"} textAlign={"center"} sx={{ "@media (max-width: 1194px)": { mt: "0rem" } }}>
              <Button
                onClick={() => setMoveTopicTriggered(false)}
                size="small"
                sx={{ backgroundColor: colorSchemes.transparent, color: colorSchemes.black, border: `1px solid ${colorSchemes.crossIconBorder}`, padding: "0.4em 1.5em", borderRadius: "0.15rem", textTransform: "none", ":hover": { backgroundColor: colorSchemes.transparent, color: colorSchemes.black, border: `1px solid ${colorSchemes.crossIconBorder}` } }}
              >
                Close
              </Button>
            </Box>
          )}
        </StyledTopicSideBarInfoBox>
      </Stack>
    </React.Fragment>
  );
};

// Memoized: re-renders only when its props or store values change, not on
// every render of the page around it (e.g. each keystroke in the message box).
export default React.memo(Topics);
